import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { syncPlayerServicesUrlOverrideFromQuery } from '@/entities/video/components/SmartTagPlayer/utils/playerServicesUrlOverride';

/**
 * Persists `?player_services_url=` on any route so overrides survive navigation to
 * pages that mount Smart Tag later. Mount once near the app root.
 */
export function PlayerServicesUrlOverrideBootstrap(): null {
    const router = useRouter();

    useEffect(() => {
        syncPlayerServicesUrlOverrideFromQuery();
    }, [router.asPath]);

    return null;
}
